import { NgModule } from '@angular/core';
import { UpdatemodalPage } from './updatemodal';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    UpdatemodalPage
  ],
  imports: [
    IonicModule,
    CommonModule
  ],
  entryComponents: [
    UpdatemodalPage
  ]
})
export class UpdatemodalPageModule {}
